import { render } from "./FullView.vue?vue&type=template&id=74856a00&scoped=true"
import script from "./FullView.vue?vue&type=script&lang=js"
export * from "./FullView.vue?vue&type=script&lang=js"

import "./FullView.vue?vue&type=style&index=0&id=74856a00&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74856a00"]])

export default __exports__